import { StyleSheet } from 'react-native';
import {
  SLIDER_CONTAINER_CROP_HEIGHT,
  SLIDER_CONTAINER_HEIGHT,
  SLIDER_CROP_WIDTH,
  SLIDER_DOT_CROP_WIDTH,
  SLIDER_DOT_WIDTH,
  SLIDER_WIDTH,
} from './Slider.constants';
import { brand, neutrals } from 'src/theme/colors';
import { FOCUS_COLOR } from 'src/theme-v2/focus';

export const styles = StyleSheet.create({
  sliderContainer: {
    height: SLIDER_CONTAINER_HEIGHT,
    justifyContent: 'center',
    cursor: 'pointer',
  },
  sliderTrack: {
    width: SLIDER_WIDTH,
    height: 6,
    backgroundColor: `${neutrals.coldGrays.marble}`,
    borderRadius: 25,
    justifyContent: 'center',
    zIndex: 1,
  },
  sliderTrackActive: {
    backgroundColor: brand.main.water,
    position: 'absolute',
    top: 0,
    height: 6,
    borderRadius: 25,
  },
  sliderHandle: {
    width: SLIDER_DOT_WIDTH,
    height: SLIDER_DOT_WIDTH,
    backgroundColor: brand.main.water,
    borderRadius: 100,
    position: 'absolute',
    zIndex: 2,
  },
  button: {
    borderWidth: 2,
    borderColor: 'transparent',
    position: 'absolute',
    marginTop: -4,
    marginLeft: -4,
  },
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
});

export const stylesCustom = StyleSheet.create({
  sliderContainer: {
    height: SLIDER_CONTAINER_CROP_HEIGHT,
    justifyContent: 'center',
    cursor: 'pointer',
  },
  sliderTrack: {
    width: SLIDER_CROP_WIDTH,
    height: 6,
    backgroundColor: `${neutrals.coldGrays.marble}`,
    borderRadius: 25,
    justifyContent: 'center',
    zIndex: 1,
  },
  sliderTrackActive: {
    backgroundColor: brand.main.water,
    position: 'absolute',
    top: 0,
    height: 6,
    borderRadius: 25,
  },
  sliderHandle: {
    width: SLIDER_DOT_CROP_WIDTH,
    height: SLIDER_DOT_CROP_WIDTH,
    backgroundColor: brand.main.water,
    borderRadius: 100,
    position: 'absolute',
    zIndex: 2,
  },
  button: {
    borderWidth: 2,
    borderColor: 'transparent',
    position: 'absolute',
    marginTop: -4,
    marginLeft: -4,
  },
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
});
